import { IOrderState } from '@/store/order';
import { IOrderMutations } from './mutations.types';
import { IOrderData } from '@/models';

export const mutations: IOrderMutations = {
  SET_COUNT(state: IOrderState, payload: number): void {
    state.count = payload;
  },

  INCREMENT_COUNT(state: IOrderState): void {
    state.count += 1;
  },

  DECREMENT_COUNT(state: IOrderState): void {
    state.count -= 1;
  },

  SET_ORDERS(state: IOrderState, payload: IOrderData[]): void {
    state.orders = payload;
  },

  ADD_ORDER(state: IOrderState, payload: IOrderData): void {
    state.orders.unshift(payload);
  },

  UPDATE_ORDER(state: IOrderState, payload: IOrderData): void {
    const index = state.orders.findIndex(
      (order: IOrderData) => order.series === payload.series
    );

    state.orders.splice(index, 1, payload);
  },

  REMOVE_ORDER(state: IOrderState, payload: string): void {
    const index = state.orders.findIndex(
      (order: IOrderData) => order.series === payload
    );

    state.orders.splice(index, 1);
  },

  SET_LAST_PROMISE(state: IOrderState, payload: Promise<any>): void {
    state.lastPromise = payload;
  }
};
